import React from 'react';
import Contact from '../components/contact/Contact';
import About from '../components/about/About';
import GetStarted from '../components/getStarted/GetStarted';
import Services from '../components/services/Services';
import Clients from '../components/about/Clients';
import VideoHolder from '../components/getStarted/VideoHolder';

const Index = () => {
  return (
    <div>
      <GetStarted />
      <VideoHolder />
      <Services />
      <About />
      <Clients />
      <Contact />
    </div>
  );
};

export default Index;
